import React from 'react';
import { Box, TextField, Typography } from '@mui/material';
import { NICKNAME_MAX_LENGTH } from '../../../hooks/useUserProfile';
import theme from '../../../theme';
import GradeIcon from '../../../components/common/GradeIcon';

const NicknameField = ({ isEditing, profileForm, handleProfileInputChange, grade }) => {
  return (
    <>
      {isEditing ? (
        <TextField
          fullWidth
          name="nickname"
          value={profileForm?.nickname || ''}
          onChange={handleProfileInputChange}
          autoFocus
          inputProps={{
            maxLength: NICKNAME_MAX_LENGTH,
          }}
          sx={{
            width: '100%',
            '& .MuiInputBase-root': {
              fontSize: '14px',
              padding: '8px 12px',
              height: '48px',
              fontFamily: 'inherit',
              color: theme.palette.black[9],
              backgroundColor: 'transparent',
              borderRadius: '4px',
              '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                border: `1px solid ${theme.palette.grey.line}`,
                outline: 'none',
              },
              '& .MuiOutlinedInput-notchedOutline': {
                border: `1px solid ${theme.palette.grey.line}`,
              },
            },
            '& .MuiInputBase-input': { padding: 0 },
          }}
        />
      ) : (
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, minHeight: '24px' }}>
          <Typography
            sx={{
              fontSize: { xs: '16px', md: '18px', lg: '20px' },
              fontWeight: 700,
              color: theme.palette.black[6],
            }}
          >
            {profileForm?.nickname || ''}
          </Typography>
          <GradeIcon grade={grade} size={20} />
        </Box>
      )}
    </>
  );
};

export default NicknameField;
